export default __webpack_public_path__ + "static/media/facebook-loginPage.67b61ee7.svg";